<template>
    <div>
        <v-card>
            <v-card-title>Listado de Cuentas</v-card-title>
            <v-card-text>
                <botonera 
                    :botones="botones" 
                    alinear="right"
                    @crear="dialog = !dialog"
                    @cargar="upload = !upload"
                    @eliminar="deleteAll"
                ></botonera>
            </v-card-text>
        </v-card>

        <datatable 
            :cabeceras="cuentasListHeaders" 
            :items="cuentasListBody" 
            titulo="Listado de Cuentas" 
            label="Escriba para buscar Cuentas" 
            icono="list" 
            color_icono="azul" 
            :tachar="false"
            :acciones="['editar','eliminar']"
            @editar="editCuenta($event)"
            @eliminar="deleteCuenta($event)">
        </datatable>

        <!-- Modal Nueva Cuenta -->
        <v-dialog
            v-model="dialog"
            width="900px"
            @click:outside = "closeModal"
        >
            <v-card>
                <v-card-title class="blue darken-1">{{ title }}</v-card-title>
                <v-card-text>
                    <form>
                        <v-row class="mx-2">
                            <v-col
                                class="align-center justify-space-between"
                                cols="6"
                            >
                                <v-text-field
                                    prepend-icon="mdi-barcode"
                                    placeholder="Nombre Cuenta"
                                    v-model="cuenta.nombre"
                                >
                                </v-text-field>
                            </v-col>
                            <v-col
                                class="align-center justify-space-between"
                                cols="6"
                            >
                                <v-text-field
                                    prepend-icon="mdi-barcode"
                                    placeholder="Codigo"
                                    v-model="cuenta.codigo"
                                >
                                </v-text-field>
                            </v-col>
                        </v-row>
                    </form>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        @click="closeModal"
                    >Cerrar</v-btn>
                    <v-btn
                        color="primary"
                        @click="saveCuenta"
                    >Grabar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- / Modal -->

        <!-- Modal upload -->
        <v-dialog
            v-model="upload"
            width="600px"
        >
            <v-card>
                <v-card-title class="green darken-1">
                    Subir listado de cuentas desde excel
                </v-card-title>
                <v-card-text>
                    <v-row class="mx-2">
                        <div class="col">
                            <v-file-input v-model="file" accept=".xls, .xlsx" label="Archivo Excel"></v-file-input>
                        </div>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        @click="upload = false"
                    >Cancelar</v-btn>
                    <v-btn
                        color="primary"
                        @click="uploadCuentas"
                    >Subir</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- / Modal -->
    
        <v-snackbar
            v-model="snackbar"
            :timeout="5000"
            :color="color"
        >
            {{ validation_message }}
            <template v-slot:action="{ attrs }">
                <v-btn
                    color="white"
                    text
                    v-bind="attrs"
                    @click="snackbar = false"
                >
                    Cerrar
                </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>
<script>
import {mapState, mapMutations} from 'vuex'
import DataTable from '@/components/base/DataTable.vue';

export default {
    data: () => ({
        title: 'Nueva Cuenta',
        color: 'green',
        snackbar: false,
        errors: [],
        validation_message: '',
        search: null,
        file: null,
        dialog: false,
        upload: false,
        changeState: false,
        cuentaIndex: -1,
        cuenta: {
            id: 0,
            nombre: '',
            codigo: '',
        },
        cuentasListHeaders: [
            {
                text: 'Id',
                align: 'center',
                sortable: true,
                value: 'id',
                class: "blue-grey darken-4 white-text"
            },
            {
                text: 'Agrupación de cuentas',
                align: 'left',
                sortable: true,
                value: 'nombre',
                class: "blue-grey darken-4 white-text"
            },
            {
                text: 'Codigo',
                align: 'left',
                sortable: true,
                value: 'codigo',
                class: "blue-grey darken-4 white-text"
            },
            {
                text: 'Acciones',
                align: 'center',
                sortable: false,
                value: 'actions',
                class: "blue-grey darken-4 white-text"
            },
        ],
        cuentasListBody: [],
        botones:[
            {boton:'crear',tooltip:'Nueva Cuenta'},
            {boton:'cargar',tooltip:'Carga Masiva'},
            {boton:'eliminar',tooltip:'Borrar Todo'}
        ]
    }),
    mounted() {
        this.loadCuentas();
    },
    methods:{
        async loadCuentas(){
            let url = `${this.base_url}cuentas`;
            await this.axios.get(url, this.headers).then((response)=>{
                this.cuentasListBody = response.data;
            }).catch((error)=>{
                console.log(error);
            });
        },
        async saveCuenta(){
            // validaciones
            this.errors = [];
            if(!this.cuenta.nombre){
                this.errors.push("Debe indicar nombre del cuenta");
            }else if(this.cuenta.nombre.length > 50){
                this.errors.push("Tamaño máximo 50 caracteres");
            }
            if(!this.cuenta.centro_costos){
                this.errors.push("Debe indicar centro de costos");
            }else if(this.cuenta.centro_costos.length > 2){
                this.errors.push("Tamaño máximo 2 caracteres");
            }
            if(this.errors.length > 0){
                this.validation_message = this.errors.join();
                this.showSnackBar(true);
                return;
            }
            let url = `${this.base_url}cuentas`;
            let cuentaData = {
                'nombre': this.cuenta.nombre,
                'codigo': this.cuenta.codigo,
                'mostrar': 1
            };
            if(this.cuenta.id > 0){
                url = url + "/" + this.cuenta.id;
                await this.axios.put(url, cuentaData, this.headers).then((response)=>{
                    let index = this.cuentasListBody.map(cuenta => {
                        return cuenta.id;
                    }).indexOf(this.cuenta.id);
                    this.cuentasListBody.splice(index, 1, response.data);
                    this.showSnackBar(false);
                }).catch((error)=>{
                    this.validation_message = error;
                    this.showSnackBar(true);
                });
            }else{
                await this.axios.post(url, cuentaData, this.headers).then((response)=>{
                    this.cuentasListBody.push(response.data);
                    this.showSnackBar(false);
                }).catch((error)=>{
                    this.errors = error.response.data;
                    this.validation_message = this.errors.join();
                    this.showSnackBar(true);
                });
            }
            this.cleanForm();
        },
        editCuenta(item) {
            this.cuentaIndex = this.cuentasListBody.indexOf(item);
            this.cuenta = Object.assign({}, item);
            this.dialog = true;
            this.title = "Editar Cuenta";
        },
        async deleteCuenta(item) {
            this.$confirm('Desea borrar esta cuenta?').then(res => {
                if(res){
                    let url = `${this.base_url}cuentas/${item.id}`;
                    this.axios.delete(url, this.headers).then((response)=>{
                        console.log(response);
                        this.loadCuentas();
                        this.showSnackBar(false);
                    }).catch((error)=>{
                        this.validation_message = error;
                        this.showSnackBar(true);
                    });
                }
            });
        },
        showSnackBar(error){
            if(error){
                this.color = 'red';
            }else{
                this.color = 'green';
                this.validation_message = "Ejecutado exitosamente!";
            }
            this.snackbar = true;
        },
        closeModal(){
            this.cleanForm();
            this.dialog = false;
            this.error = null;
            this.title = "Nuevo Cuenta";
        },
        cleanForm(){
            this.cuenta.id = 0;
            this.cuenta.nombre = "";
            this.cuenta.empresa = null;
            this.dialog = false;
        },
        async uploadCuentas(){
            this.headers.headers['Content-Type'] = "multipart/form-data";
            let url = `${this.base_url}uploads/cuentas`;
            let formData = new FormData();
            formData.append("excel", this.file);
            let response = null; 
            try{
                response = await this.axios.post(url, formData, this.headers);
                this.file = null;
                this.upload = false;
                this.loadCuentas();
                this.showSnackBar(false);
            }catch(error){
                response = error.response;
                let msg = response.data.data;
                this.validation_message = response.status + ': ' + response.data.message + '. '+ msg;
                this.showSnackBar(true);
            }
        },
        async deleteAll(){
            this.$confirm('Desea borrar todos los datos?').then(res => {
                if(res){
                    let url = `${this.base_url}truncar/cuentas`;
                    this.axios.get(url, this.headers).then((response)=>{
                        console.log(response);
                        this.loadCuentas();
                        this.showSnackBar(false);
                    }).catch((error)=>{
                        this.validation_message = error;
                        this.showSnackBar(true);
                    });
                }
            });
        },
        async ocultar(item) {
            this.$confirm('Desea ocultar esta cuenta?').then(res => {
                if(res){
                    let url = `${this.base_url}cuentas/ocultar/${item.id}`;
                    this.axios.get(url, this.headers).then((response)=>{
                        console.log(response);
                        this.showSnackBar(false);
                        this.loadCuentas();
                    }).catch((error)=>{
                        this.validation_message = error;
                        this.showSnackBar(true);
                    });
                }
            });
        },
        async mostrar(item) {
            this.$confirm('Desea mostrar esta cuenta?').then(res => {
            if(res){
                let url = `${this.base_url}cuentas/mostrar/${item.id}`;
                this.axios.get(url, this.headers).then((response)=>{
                    console.log(response);
                    this.showSnackBar(false);
                    this.loadCuentas();
                }).catch((error)=>{
                    this.validation_message = error;
                    this.showSnackBar(true);
                });
            }
            });
        },
        ...mapMutations(['actualizarBaseUrl', 'mostrarLoading', 'ocultarLoading']),
    },
    computed:{
        ...mapState(['loading', 'base_url', 'headers']),
    },
    components:{
        'datatable': DataTable
    }
  }
</script>